
// import logPrice from '../logprice/logprice.vue'
import panelPrice from '../panelPrice/panelPrice.vue'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import compLog from '@/views/private/realestate/pricetablemanagement/components/compLog/compLog.vue'
import templatePrice from '../templatePrice/templatePrice.vue'
import fileUploaderPrice from '../fileUploaderPrice/fileUploaderPrice.vue'
import Mirrorsalesenterprise from '../../../enterprise/components/mirrorsalesenterprise/mirrorsalesenterprise.vue'
import EnterpriseLogArchiveRepository from '@/shared/http/repositories/realestate/enterpriselogarchive'

const Tabs = {
  Opção1: 0,
  Opção2: 1,
  Opção3: 2
}

export default {
  components: {panelPrice, HeadDetailsGama, compLog, templatePrice, fileUploaderPrice, Mirrorsalesenterprise},
  name: 'detailsPrice',
  props: ['selectedEnterprise'],

  data () {
    return {
      headTable: ['Opção 1', 'Opção 2', 'Opção 3', 'Opção 4', 'Opção 5', 'Opção 6', 'Opção 7', 'Opção 8', 'Opção 9', 'Opção 10', 'Opção 11', 'Opção 12'],
      tabIndex: Tabs.Detalhes,
      dataLog: []
    }
  },
  mounted () {
    this.CreateLog(this.selectedEnterprise.id)
  },
  methods: {
    openTemplatePriceFather () {
      this.$refs['add-user-modal'].show()
    },
    closeTemplatePriceFather () {
      this.$refs['add-user-modal'].hide()
    },
    CreateLog (eId) {
      EnterpriseLogArchiveRepository.GetByEmpreendimento(eId)
        .then(Response => {
          this.dataLog = Response.data.data
          this.$refs.tableGrid.LoadAllByData(Response)
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/pricetablemanagement/components/detailsPrice/detailsPrice.js